// react
import { Link } from 'react-router-dom';

// components
import { SearchBar } from '../components';

const Navbar = () => {
  return (
    <nav className='bg-black/30'>
      <div className='w-full grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7'>
        <Link to='/' className='col-span-1 flex items-center space-x-2 px-2.5 py-4 bg-black/40'>
          <span className='w-10 h-8 flex items-center justify-center border-2 border-red-600 rounded-md'>
            <svg className='w-2.5 fill-white' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
              <path d='M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z' />
            </svg>
          </span>
          <span className='text-lg'>
            <span className='font-bold'>YT</span> Clone
          </span>
        </Link>

        <div className='lg:col-span-4 xl:col-span-5 2xl:col-span-6 flex items-center justify-between space-x-3 -mr-2.5 pl-2.5 pr-5 py-3'>
          <SearchBar />

          <span className='h-full aspect-square flex items-center justify-center bg-gray-900 rounded'>
            <svg className='w-4 fill-gray-400' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
              <path d='M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z' />
            </svg>
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
